import ClasImpl from '@/serviceImpl/ClasImpl';
import {Precinct} from '@/domain/entities/Precinct';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';

const getPrecinctByPointOfInterest = async (year?: number, pointOfInterest?: {lng: number, lat: number}): Promise<Precinct | undefined> => {
  const accessToken = getCredentialsOrThrow();

  if(!pointOfInterest || !year) return;

  const {lng, lat} = pointOfInterest;

  try {
    const result = await ClasImpl.getPrecinctByPointOfInterest(year,`POINT(${lng} ${lat})`, accessToken);

    if(result.length === 0) return undefined;
    if(result.length === 1) return result[0];
    if(result.length !== 1) {
      console.info('There is more than one precinct, the first one has been returned');
      return result[0];
    }

  } catch (error) {
    console.error('Error fetching precinct by Point of interest', error);
    throw error;
  }

};

export default getPrecinctByPointOfInterest;